/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-16 18:31:40
 * @modify date 2021-08-16 18:31:40
 * @desc [description]
 */
import * as Mamba from '@mamba/clients';
import { message } from 'antd';
import lodash from 'lodash';
import NProgress from 'nprogress';
import React from 'react';
import { $AppConfig } from './global';
import $Store from './store';
// if (!$AppConfig.development) {
//     // 设置默认的 AjaxBasics 配置
//     Mamba.AjaxBasics.resetDefault({
//         target: $AppConfig.target,
//         headers:{}
//     })
// }
Mamba.AjaxBasics.resetDefault({
  headers: {
    'x-client-info': `platform=${Mamba.EnumCustomPlatform.pc};version=${$AppConfig.version}`,
  },
});
Mamba.AjaxBasics.onStart = (AjaxConfig) => {
  if ($AppConfig.userAgent.isIE) {
    // 解决 ie 缓存
    lodash.merge(AjaxConfig.queryParams, { _t: Date.now() });
  }
  if (lodash.get(AjaxConfig, 'loading')) {
    NProgress.start();
  }
};
Mamba.AjaxBasics.onEndAll = NProgress.done;
Mamba.AjaxBasics.onError = (error, AjaxConfig) => {
  if (lodash.get(AjaxConfig, 'interceptErrMsg')) {
    return;
  }
  // if (lodash.includes([''], lodash.get(error, 'status'))) {
  //   return BindMobile()
  // }
  if (
    lodash.includes(
      [
        Mamba.EnumAPI.cultivate_get_yxt_url.url,
        Mamba.EnumAPI.legal_portal_protocol_save.url,
      ],
      AjaxConfig.url,
    )
  ) {
    return;
  }
  if (lodash.eq(error.responseType, 'blob')) {
    let reader = new FileReader();
    reader.onload = () => {
      let content = String(reader.result);
      message.error(lodash.get(JSON.parse(content), 'msg'));
    };
    reader.readAsText(error.response);
    return;
  }
  if (lodash.includes(error.message, 'ajax')) {
    error.message = '当前访问用户过多，请稍后再试';
  }
  const msg = lodash.find(
    lodash.compact([
      lodash.get(error, 'message'),
      lodash.get(error, 'msg'),
      '当前访问用户过多，请稍后再试',
    ]),
    lodash.isString,
  );
  const status = lodash.get(error, 'status');
  if (
    lodash.includes(
      [Mamba.EnumStatusCode.illegalToken, Mamba.EnumStatusCode.invalidToken],
      status,
    )
  ) {
    $Store.System.onLoginOut();
    $AppConfig.onClear();
    // $AppConfig.onRemoveAllCookie();
  }
  message.error(msg, 6);
};
lodash.set(React, '$Mamba', Mamba);
declare module 'react' {
  /** Mamba */
  const $Mamba: typeof Mamba;
}
